// Provider IDs verified against TMDB /watch/providers on 2026-05-02.

const SEEDED_LANGUAGES = {
  'en-us': 'en-US',
  'th-th': 'th-TH',
  'fr-fr': 'fr-FR',
  'es-es': 'es-ES',
  'ja-jp': 'ja-JP',
  'ko-kr': 'ko-KR'
}

const LANGUAGE_PREFIXES = {
  en: 'en-US',
  th: 'th-TH',
  fr: 'fr-FR',
  es: 'es-ES',
  ja: 'ja-JP',
  ko: 'ko-KR'
}

export const CURATED_PROVIDERS = {
  US: [8, 15, 9, 350, 337, 1899, 386],
  FR: [8, 119, 337, 350, 381, 1754, 147],
  TH: [
    8,
    119,
    350,
    122,
    158,
    2283 // substituted for iQiyi - not in TMDB TH provider list
  ]
}

function getDisplayPriority(provider) {
  const priority = Number(provider?.display_priority)
  return Number.isFinite(priority) ? priority : Infinity
}

export function resolveProviderSet(region, regionProvidersFromTMDB) {
  const normalizedRegion = typeof region === 'string' ? region.toUpperCase() : ''

  if (CURATED_PROVIDERS[normalizedRegion]) {
    return CURATED_PROVIDERS[normalizedRegion].slice()
  }

  if (!Array.isArray(regionProvidersFromTMDB) || regionProvidersFromTMDB.length === 0) {
    return []
  }

  return regionProvidersFromTMDB
    .slice()
    .sort((a, b) => getDisplayPriority(a) - getDisplayPriority(b))
    .slice(0, 6)
    .map(provider => provider?.provider_id)
    .filter(providerId => providerId != null)
}

export function guessRegionFromTimezone() {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    if (timeZone === 'Asia/Bangkok') return 'TH'
    if (timeZone === 'Europe/Paris') return 'FR'
    if (typeof timeZone === 'string' && timeZone.startsWith('Europe/')) return 'US'
    if (typeof timeZone === 'string' && timeZone.startsWith('America/')) return 'US'
  } catch (error) {
    // Fall back to the default seed region outside the browser.
  }

  return 'US'
}

export function guessLanguageFromNavigator() {
  try {
    const language = navigator.language

    if (typeof language !== 'string' || !language) {
      return 'en-US'
    }

    const normalizedLanguage = language.trim().replace(/_/g, '-').toLowerCase()

    if (SEEDED_LANGUAGES[normalizedLanguage]) {
      return SEEDED_LANGUAGES[normalizedLanguage]
    }

    const languagePrefix = normalizedLanguage.split('-')[0]
    return LANGUAGE_PREFIXES[languagePrefix] || 'en-US'
  } catch (error) {
    return 'en-US'
  }
}
